export default "__VITE_ASSET__ETSgomim__"